/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
 import styled from 'styled-components';
/**
 * Estilização do componente StyledPopoverOpacity
 */
 export const Wrap = styled.div`
    .header {
    display: flex;
    justify-content: space-between;

    h3 {
      font-family: Roboto;
      font-style: normal;
      font-weight: 300;
      font-size: 16px;
      line-height: 19px;
      color: #5e6366;
    }

    .btn-close {
      transform: translate(20px, -21px);
      svg {
        color: #bdbcbc;
        width: 17px;
      }
    }

    @media (max-width: 768px) {
      display: none;
    }
  }

  hr {
    margin: 0 0 20px 0;
    @media (max-width: 768px) {
      display: none;
    }
  }

  .content {    
    max-height: 500px;
    max-width: ${({ maxWidth }) => (maxWidth ? maxWidth : '430px')};
    overflow: auto;

    .loader {
      min-height: 60px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(255, 255, 255, 0.8);
      color: #5e5e5e;
      z-index: 5;
    }

    @media (max-width: 768px) {
      max-height: unset;
      overflow: unset;
      padding-bottom: 20px;
    }
  }
`;